<!--
 * @Descripttion: 
 * @version: 
 * @Author: alex.yang
 * @Date: 2022-03-30 14:37:36
 * @LastEditors: alex.yang
 * @LastEditTime: 2022-07-08 15:17:29
-->
<template>
  <div id="app">
    <!-- <router-view/> -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <!-- 不缓存的页面，不缓存$route.meta.keepAlive为false的组件 -->
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>

export default {
  name: "App",
  beforeCreate() {
    // let userInfo = saGetUserInfo();
    // saSetToken();
    // if (this.$route.path !== "/signIn" && this.$route.path !== "/admin" && this.$route.path !== "/") {
    //   if (!userInfo) {
    //     this.$message.error("无用户登录信息,请输入账号密码");
    //     this.$router.push("/signIn");
    //   } else {
    //     // this.$router.push("/home");
    //   }
    // } else {
    //   if (userInfo) {
    //     // this.$router.push("/home");
    //   } else {
    //     this.$router.push("/signIn");
    //   }
    // }
  },
};
</script>

<style lang="scss">
html,
body {
  margin: 0px;
  padding: 0px;
  width: 100%;
  height: 100%;
}
#app {
  width: 100%;
  height: 100%;
  font-family: "Microsoft Yahei Regular", "SF Pro SC", "SF Pro Display",
    "SF Pro Icons", "PingFang SC", "Helvetica Neue", "Helvetica", "Arial",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #000;
  .warning-row{
      background: #e6a23c;
  }
  .danger-row{
      background: #f56c6c;
  }
  .info-row{
      background: #dddddd;
  }
}

</style>
